import React, { useEffect, useMemo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from 'shared/components/form/button';
import { BackButtonIcon, ChartIcon } from 'shared/icons/icon';
import localizationConstants from 'shared/util/translation/constants';
import { Translate } from 'shared/util/translation/translate';

import '../style/chartScreenContainer.scss';
import ChartScreenContainer from './chartScreenContainer';
import { useAdvanceChartConfig } from '../hooks/useAdvanceChartConfig';

const FutureTableContainer: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { chartSettings } = useAdvanceChartConfig();

	const { t } = useTranslation();
	const compareChartValue = useMemo(() => {
		if (chartSettings.length > 1) {
			const [firstName, secondName] = chartSettings.map((setting) => setting.name.split(' ')[0]);
			return `${t(localizationConstants.comparison)} ${firstName} / ${secondName}`;
		}
		return '';
	}, [chartSettings, t]);

	const [compareValue, setCompareValue] = useState(compareChartValue);

	useEffect(() => {
		const newValue = location.state?.name || compareChartValue || '';
		setCompareValue(newValue);
	}, [compareChartValue, location.state]);

	return (
		<div
			className={`future-table__container ${
				location.search.includes('isIframe') ? 'pt-16 pb-10 pr-20 pl--20' : 'height--100vh-75px pt-0 pb-0'
			}`}
			id='scrollable-wrapper'
		>
			{!location.hash && (
				<section className='futuretable-section full-width'>
					{!location.search.includes('isIframe') && (
						<div className='futuretable-header d-flex justify-content-space-start align-items-center'>
							<Button
								btnType='secondary'
								onClick={() => navigate(-1)}
								className='button button-secondary padding-left-right--16px text-capitalize back--btn d-flex justify-content-space-between align-items-center font--14px b-radius--8 mr-16'
							>
								<BackButtonIcon className='mr-6' />
								<Translate text={localizationConstants.back} />
							</Button>
							{!isEmpty(chartSettings) && chartSettings.length > 1 && !location.pathname.includes('futureTable') && (
								<div className='compar-wrapper full-width max-width-390px d-flex justify-content-start align-items-start b-radius--8 bg-color-sky-blue border-color--primary'>
									<div className='icon__wrapper mr-15'>
										<ChartIcon className='width--32px width--32px' />
									</div>
									<input
										type='text'
										className='compare-input full-width d-flex justify-content-center align-items-center font--16px font-weight--500'
										onChange={(e) => setCompareValue(e.target.value)}
										defaultValue={compareValue}
									/>
								</div>
							)}
						</div>
					)}
					<ChartScreenContainer compareValue={compareValue} />
				</section>
			)}
		</div>
	);
};

export default FutureTableContainer;
